/**
 * Server-side analytics events (Sept 2026, Part 2 dashboard).
 *
 * Fires the SAME commerce events as the Meta Pixel (ATC and
 * InitiateCheckout) to our OWN server so the admin funnel shows a
 * reliable count that isn't gated on ad-blocker/browser pixel policy.
 *
 * Fire-and-forget. Never throws — analytics MUST NOT block or break
 * the cart/checkout flow. Uses the shared `tbb_session_id` so the funnel
 * can join pageviews → carts → checkout per session.
 */
import { api } from "@/lib/api";
import { getSessionId, isInternalSession, isPreviewHost } from "@/lib/session";
import { isBotClient } from "@/lib/botGuard";

async function fire(event, extra = {}) {
  try {
    if (isBotClient()) return;
    await api.post("/analytics/event", {
      event,
      session_id: getSessionId(),
      path: typeof window !== "undefined" ? window.location.pathname : null,
      internal: isInternalSession() || isPreviewHost(),
      ...extra,
    });
  } catch {
    /* silent — analytics never breaks the flow */
  }
}

export function trackServerATC({ subtotal, itemCount, itemName, itemSlug } = {}) {
  return fire("atc", { subtotal, item_count: itemCount, item_name: itemName, item_slug: itemSlug });
}

export function trackServerInitiateCheckout({ subtotal, itemCount } = {}) {
  return fire("initiate_checkout", { subtotal, item_count: itemCount });
}
